import { memo } from 'react';
import { useRouter } from 'next/router';

import { Box, Paragraph } from '@zillow/constellation-10';

import { useGetListingDetails } from '../../../../hooks/queries/properties';

import { REVIEW_PAGE_SECTIONS } from '../../../../constants/ListingDetailConstants';

import PetPolicyFormField from '../../../PostingPath/PetPolicyFormField';
import RecommendationsAlert from '../../../PostingPath/RecommendationsAlert';
import SpinnerContainer from '../../../SpinnerContainer';
import LeaseLengthAmenities from './LeaseLengthAmenities';
import ParkingDescriptionField from './ParkingDescriptionField';
import ParkingTypeAmenities from './ParkingTypeAmenities';
import PetPolicyDescriptionField from './PetPolicyDescriptionField';
import UtilitiesAmenities from './UtilitiesAmenities';

type Props = {
  onRecsClick: (recommendationType: string) => void;
};

const PoliciesAndTermsContent = ({ onRecsClick }: Props) => {
  const router = useRouter();
  const listingAlias = router.query.listingAlias as string;
  const { isPending } = useGetListingDetails(listingAlias);

  if (isPending) {
    return <SpinnerContainer />;
  }

  return (
    <Box data-testid="PoliciesAndTermsContent-Edit" css={{ display: 'flex', flexDirection: 'column', gap: '400' }}>
      <RecommendationsAlert sectionName={REVIEW_PAGE_SECTIONS.POLICIES_AND_TERMS} onRecsClick={onRecsClick} />

      <UtilitiesAmenities />

      <LeaseLengthAmenities />

      {/* Pet Policy Section */}
      <Box data-testid="PetsPolicyContainer" css={{ display: 'flex', flexDirection: 'column', gap: '400' }}>
        <Paragraph textStyle="body-bold">Pets</Paragraph>
        <Box css={{ display: 'flex', flexDirection: { lg: 'row', base: 'column' }, gap: '400' }}>
          <PetPolicyDescriptionField />
          <Box css={{ display: 'flex', flexDirection: 'column', gap: '400', flex: { lg: '1 1 50%', base: 'auto' } }}>
            <PetPolicyFormField />
          </Box>
        </Box>
      </Box>

      {/* Parking Section */}
      <Box data-testid="ParkingPolicyContainer" css={{ display: 'flex', flexDirection: 'column', gap: '400' }}>
        <Paragraph textStyle="body-bold">Parking</Paragraph>
        <Box css={{ display: 'flex', flexDirection: { lg: 'row', base: 'column' }, gap: '400' }}>
          <ParkingDescriptionField />
          <ParkingTypeAmenities />
        </Box>
      </Box>
    </Box>
  );
};

export default memo(PoliciesAndTermsContent);
